var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Box",
    _vm._b({}, "Box", _vm.$attrs, false),
    [
      _c(
        "VueAvatar",
        _vm._b(
          {
            class: { shadow: _vm.shadow },
            attrs: {
              rounded: _vm.rounded,
              size: _vm.size,
              backgroundColor: _vm.backgroundColor
            }
          },
          "VueAvatar",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }